import styled from 'vue-styled-components'
import StyledButton from '@/components/styled/StyledButton'

const LogoutButton = styled(StyledButton)`
  padding: .5rem;
`

export default LogoutButton
